import { cn } from '@/lib/cn'

interface StatsCardProps {
  label: string
  value: number
  variant: 'default' | 'success' | 'error' | 'warning'
}

const variantStyles = {
  default: {
    bg: 'bg-neutral-50',
    border: 'border-neutral-200',
    text: 'text-neutral-900',
    label: 'text-neutral-500',
  },
  success: {
    bg: 'bg-success-50',
    border: 'border-success-500/20',
    text: 'text-success-700',
    label: 'text-success-600',
  },
  error: {
    bg: 'bg-error-50',
    border: 'border-error-500/20',
    text: 'text-error-700',
    label: 'text-error-600',
  },
  warning: {
    bg: 'bg-warning-50',
    border: 'border-warning-500/20',
    text: 'text-warning-700',
    label: 'text-warning-600',
  },
}

export function StatsCard({ label, value, variant }: StatsCardProps) {
  const styles = variantStyles[variant]

  return (
    <div className={cn('rounded-lg border px-4 py-3', styles.bg, styles.border)}>
      <p className={cn('text-xs font-medium', styles.label)}>{label}</p>
      <p className={cn('text-2xl font-bold mt-0.5', styles.text)}>{value}</p>
    </div>
  )
}
